import { useEffect, type Dispatch, type SetStateAction } from 'react';

/** Keeps per-system photo slot arrays aligned with HVAC/Plumbing system counts (photos are not persisted in draft). */
export function useSyncSystemPhotoSlots(systemCount: number, setPhotos: Dispatch<SetStateAction<File[][]>>) {
  useEffect(() => {
    setPhotos((prev) => {
      if (prev.length === systemCount) return prev;
      if (prev.length < systemCount) {
        return [...prev, ...Array.from({ length: systemCount - prev.length }, () => [] as File[])];
      }
      return prev.slice(0, systemCount);
    });
  }, [systemCount, setPhotos]);
}
